import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";

import Loader from "components/Custom/Loader";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";
import AutoComplete from "components/Custom/AutoComplete";
import UiAccordion from "components/Custom/UiAccordion";
import UiDialog from "components/Custom/UiDialog";
import AddSalesInvoiceSkeleton from "../../components/Sales/AddSalesInvoice/OrderSkeleton";

import { ERRORS, LABELS, SUCCESS, TITLES, WARNINGS } from "common/lables";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";

import { DEFAULTS, NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { TRANS_APIs } from "apihandlers/transaction";
import { GEO_APIs } from "apihandlers/geography";
import { CUSTOMER_APIs } from "apihandlers/customer";
import { PRODUCT_APIs } from "apihandlers/product";
import {ORDER_APIs} from "apihandlers/order"

const AddNewPhysicalVoucher = (props: any) => {
  const { hideHeader, setPageMenu, setManageDialog } = props;

  const addPhysicalVoucherRef: any = useRef(null);

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<any>(null);
  const [products, setProducts] = useState<any>([]);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  // const formulaRenderer = (row) => {
  //   console.log("formulaRenderer: ", row);
  //   let quantity = Number(row["quantity"] || 0);
  //   let price = Number(row["price"] || 0);
  //   let taxStructure = row["taxStructure"];
  //   console.log("taxStructure", taxStructure);
  //   let basic = 0;
  //   let taxAmount = 0;
  //   let cgst = 0;
  //   let sgst = 0;
  //   let total = 0;
  //   if (!isNaN(quantity) && !isNaN(price)) {
  //     basic = price * quantity;
  //     taxAmount = basic * (taxStructure.replace("%", "") / 100);
  //     cgst = sgst = taxAmount / 2;
  //     total = basic + taxAmount;
  //   }
  //   row["basic"] = basic;
  //   row["taxAmount"] = taxAmount;
  //   row["total"] = total;
  //   row["cgst"] = cgst;
  //   row["sgst"] = sgst;
  //   return row;
  // };

  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "productName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.PRODUCT,
      width: "25%",
    },
    {
      key: "closingStock",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.CONVERSION_FACTOR,
      width: "10%",
    },
    {
      key: "closingStock",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.BAG_CARTON,
      width: "10%",
    },
    {
      key: "closingStock",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.STRIP_PACKET,
      width: "10%",
    },
    {
      key: "sold",
      type: "number",
      editable: true,
      sortable: true,
      searchable: true,
      name: LABELS.ACTUAL_QTY_BAG_CARTON,
      width: "20%",
      renderSum: true,
      renderSumPrefix: "Total Quantity:",
    },
    {
      key: "soldSku",
      type: "number",
      editable: true,
      sortable: true,
      searchable: true,
      name: LABELS.ACTUAL_QTY_STRIP_PACKET,
      width: "20%",
      renderSum: true,
      renderSumPrefix: "Total Quantity:",
    },
    // {
    //   key: "price",
    //   type: "number",
    //   editable: false,
    //   sortable: true,
    //   searchable: true,
    //   name: LABELS.,
    //   width: "10%",
    //   renderSum: true,
    //   formula: formulaRenderer,
    // },
    // {
    //   key: "cgst",
    //   type: "number",
    //   editable: false,
    //   sortable: true,
    //   searchable: true,
    //   name: LABELS.CGST_AMOUNT,
    //   width: "10%",
    //   renderSum: true,
    //   renderSumPrefix: "Total CGST : ",
    //   formula: formulaRenderer,
    // },
    // {
    //   key: "sgst",
    //   type: "number",
    //   editable: false,
    //   sortable: true,
    //   searchable: true,
    //   name: LABELS.SGST_AMOUNT,
    //   width: "10%",
    //   renderSum: true,
    //   renderSumPrefix: "Total SGST : ",
    //   formula: formulaRenderer,
    // },
    // {
    //   key: "total",
    //   type: "number",
    //   editable: false,
    //   sortable: true,
    //   searchable: true,
    //   name: LABELS.AMOUNT,
    //   width: "10%",
    //   renderSum: true,
    //   renderSumPrefix: "Total Amount: ",
    //   formula: formulaRenderer,
    // },
  ];

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      setRows(null);
      const res: any = await PRODUCT_APIs.getProductsSku(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getProductsSku:", error);
    }
  };

  const mangePhysicalVoucher = () => {
    // const orderNumber = (
    //   document.getElementById("orderNumber") as HTMLInputElement
    // ).value.trim();
    // const orderDate = (
    //   document.getElementById("orderDate") as HTMLInputElement
    // ).value.trim();
    // const areaId = areasRef.current.selectedValue.id;
    // const customerId = partyRef.current.selectedValue.id;
    // const vehicleId = vehicleRef.current.selectedValue.id;
    // const branchId = branchRef.current.selectedValue.id;
    // const stockLoadId = stockRef.current.selectedValue.id;
    // const productSkuId = productRef.current.selectedValue.id;
    // const schemeId = schemeRef.current.selectedValue.id;
    // const taxAmount = (
    //   document.getElementById("taxAmount") as HTMLInputElement
    // ).value.trim();
    // const total = (
    //   document.getElementById("total") as HTMLInputElement
    // ).value.trim();
    // const basic = (
    //   document.getElementById("basic") as HTMLInputElement
    // ).value.trim();
    // const remarks = (
    //   document.getElementById("remarks") as HTMLInputElement
    // ).value.trim();
    // const sold = (
    //   document.getElementById("sold") as HTMLInputElement
    // ).value.trim();
    // const soldSku = (
    //   document.getElementById("soldSku") as HTMLInputElement
    // ).value.trim();
    // const price = (
    //   document.getElementById("price") as HTMLInputElement
    // ).value.trim();
    // const orderItemBasic = (
    //   document.getElementById("orderItemBasic") as HTMLInputElement
    // ).value.trim();
    // const orderItemTaxAmount = (
    //   document.getElementById("orderItemTaxAmount") as HTMLInputElement
    // ).value.trim();
    // const orderItemTotal = (
    //   document.getElementById("orderItemTotal") as HTMLInputElement
    // ).value.trim();
    // const offers = (
    //   document.getElementById("offers") as HTMLInputElement
    // ).value.trim();
    // let ele = document.querySelector(
    //   'input[name="activeStatus"]:checked'
    // ) as HTMLInputElement;
    // const status = ele ? ele.value : "";

    // Validations;
    // if (countryName == "") {
    //   errors.push({
    //     id: "symbol",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.COUNTRY_NAME +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    // if (countryCode == "") {
    //   errors.push({
    //     id: "symbol",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.COUNTRY_CODE +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    // if (countryDialCode == "") {
    //   errors.push({
    //     id: "code",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.COUNTRY_DIAL_CODE +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    // setMandatoryResults(errors);
    // if (errors.length > 0) {
    //   COMMON_JS.showNotify(
    //     props,
    //     NOTIFY.WARNING,
    //     WARNINGS.PLEASE_CHECK_FORM_ERRORS
    //   );
    //   return;
    // }
    const rows = addPhysicalVoucherRef.getRowData();
    const summary = addPhysicalVoucherRef.getSummary();
    console.log("summary", summary);
    setLoading(true);
    const args = {
      orderId: -1,
      // orderNumber: "123567", ORDER NUMBER TP BE GENERATED IN BACKEND
      //customerId: partyId, // SELECTEDpARTY.ID
      // orderDate: "2023-10-14 10:15:05", // BACKEND
      // areaId: 6307, BACKEND ENTRY
      taxAmount:
        Number(summary[0].cgst.replace("Total CGST : ", "")) +
        Number(summary[0].sgst.replace("Total SGST : ", "")), // frontend
      // BASIC = QTY * RATE
      // TAX AMOUNT = BASIC * TAXPC/100
      // SGST = CGST = TAX AMOUNT/2
      total: Number(summary[0].total.replace("Total Amount: ", "")), // BASIC + TAX AMOUNT
      basic: Number(summary[0].basic.replace("Total Basic : ", "")),
      status: 1, // SMALL INT
      // remarks: comments, // TEXT BOX INPUT
      //vehicleId: 33, // DONT SEND
      // branchId: 15, // FOR NOW, WE NEED TO DO IT IN BACKEND
      // stockLoadId: 2, // NULL HANDLE IN BACKEND iF MANDATORY
      // productSkuId: rows.id,
      // sold, // soldsku * gram BACKEND
      // soldSku, // THIS iS QTY
      // price,
      // orderItemBasic,
      // orderItemTaxAmount,
      // orderItemTotal,
      items: rows.map((item) => {
        return {
          orderItemId: -1,
          productSkuId: item.id,
          soldSku: item.quantity,
          price: item.price,
          orderItemBasic: Number(item.price * item.quantity),
          orderItemTaxAmount: Number(
            Number(item.price * item.quantity) *
              Number(item.taxStructure.replace("%", "") / 100)
          ),
          orderItemTotal: Number(
            Number(item.price * item.quantity) +
              Number(
                Number(item.price * item.quantity) *
                  Number(item.taxStructure.replace("%", "") / 100)
              )
          ),
        };
      }),
      // photos: [],
      // schemeId: 5, // NOT TO BE HERE, BACKEND
      // offers, // NOT TO BE SENT HERE, BACKEND
    };

    let errors = [];
    if (args.items.length === 0) {
      errors.push({
        id: "items",
        msg: WARNINGS.ITEM_IS_EMPTY,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    // setIsSubmit(true);

    console.log("args:", args);

    ORDER_APIs.manageOrder(args).then((res) => {
      // setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  return (
    <React.Fragment>
      <div className="userDashboard">
        <div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                label={LABELS.DATE}
                type={"date"}
                id="fromDate"
                defaultValue={DateFunctions.getDate(
                  "today",
                  "from",
                  "YYYY-MM-DD"
                )}
              />
            </div>
            <div className="formGroup width40"></div>
            <div className="formGroup width40"></div>
          </div>
          {rows ? (
            <>
              <div className="grid excelGridWrapper">
                <ExcelGrid
                  id={"addPhysicalVoucher"}
                  height={window.innerHeight * 0.5}
                  childRef={addPhysicalVoucherRef}
                  cols={columns}
                  rows={rows}
                  newRowOption={false}
                  exportName={LABELS.ADD_SALES_INVOICE}
                  // onReload={reloadGrid}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "right",
                  width: "97%",
                }}
              >
                <div
                  style={{
                    width: "35%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <Btn
                    text={LABELS.SAVE}
                    onClick={mangePhysicalVoucher}
                    marginRight={15}
                    bgColor={COLORS.GRID_ADD_NEW}
                    //  loading={isSubmit}
                  />
                </div>
              </div>
            </>
          ) : (
            <AddSalesInvoiceSkeleton />
          )}
        </div>
        {mandatoryResults.length > 0 && (
          <div className="mandatoryBox">
            <ul>
              {mandatoryResults.map((m) => {
                return (
                  <li>
                    <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(AddNewPhysicalVoucher);
